<div class="map-panel-content" [class.with-footer]="mapPanelFooter.hasChildNodes()">
  <ng-content select="div[role=content]"></ng-content>
</div>
<div class="map-panel-footer" #mapPanelFooter>
  <ng-content select="div[role=footer]"></ng-content>
</div>
